import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import BaseMapView, { styles } from '../../views/global_cockpits/BaseMapView';


@withStyles(styles)
@observer
class DemandMapView extends BaseMapView {
  static apiSubPath = '/demand_map/';

  title = 'Demand map';

  @observable kpi = 'demand';
  @observable granularity = 'cbu';

  get kpiChoices() {
    return [
      { value: 'demand', display_name: 'Demand' },
      { value: 'availability_fg', display_name: 'FG sales coverage' },
      ...super.kpiChoices,
    ]
  }

  get granularityChoices() {
    return [
      { value: 'cbu', display_name: 'CBU' },
      ...super.granularityChoices,
    ];
  }

  isRatioKpi(kpiName) {
    return kpiName === 'availability_fg';
  }

  isGreyKpi(kpiKey) {
    return kpiKey === 'demand_volume' || kpiKey === 'demand_value';
  }
}


export default DemandMapView;
